import BaseApi from 'apis/BaseApi';

export interface ReportStatistics {
  // // API lấy danh sách báo cáo theo khách hàng
  // GetByCustomerReport: (beginTime: string, endTime: string) => Promise<any>;
  // // API lấy danh sách báo cáo theo NV KD
  // GetBySellStaffReport: (beginTime: string, endTime: string) => Promise<any>;
  // API lấy danh sách báo cáo theo NV KT
  GetByTechStaffReport: (userName: any, ctyQuanLy: any, beginTime: string, endTime: string) => Promise<any>;
  DetailTheoKhachHang: (data: any) => Promise<any>;
  // // API lấy danh sách báo cáo theo Xuất nhập kho
  // GetInOutStockReport: (beginTime: string, endTime: string) => Promise<any>;
  // // API lấy danh sách báo cáo theo Lịch sử thao tác
  // GetActionHistoryReport: (beginTime: string, endTime: string) => Promise<any>;
}

const ReportStatisticsApi: ReportStatistics = {
  GetByTechStaffReport: (userName: any, ctyQuanLy: any, beginTime: string, endTime: string) => {
    return BaseApi.GET(
      `api/Report/CountDonHangGroupByTime?userName=${userName}&ctyQuanLy=${ctyQuanLy}&beginTime=${beginTime}&endTime=${endTime}`
    );
  },
  DetailTheoKhachHang: (data: any) => {
    return BaseApi.POST(`api/Report/DetailTheoKhachHang`, data);
  }
};

export default ReportStatisticsApi;
